/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";

import { ArrowDownIcon } from "./ArrowDownIcon/ArrowDownIcon";

import type { ChangeEventHandler } from "react";
import type { FcWithoutChildren } from "types/fcWithoutChildren";

type Place = {
  name: string;
  placeCode: string;
};

type Props = {
  onFulfillmentSelect: (placeCode: Place["placeCode"]) => void;
  places: Place[];
  selectedPlaceCode: Place["placeCode"];
};

export const FulfillmentSelect: FcWithoutChildren<Props> = (props) => {
  const { onFulfillmentSelect, places, selectedPlaceCode } = props;
  const handleChange: ChangeEventHandler<HTMLSelectElement> = (event) => {
    onFulfillmentSelect(event.currentTarget.value);
  };

  return (
    <div css={rootStyle}>
      {/* TODO: 多言語対応 https://github.com/balus-co-ltd/spwn/issues/11159 */}
      {/* eslint-disable-next-line no-restricted-syntax -- i18n 未対応 */}
      <h3 css={heading3Style}>受け取り場所</h3>

      <div css={selectWrapperStyle}>
        <ArrowDownIcon css={iconStyle} height={6} width={10} />

        <select
          css={selectStyle}
          defaultValue={selectedPlaceCode}
          name="fulfillmentSelect"
          onChange={handleChange}
        >
          {/* TODO: デフォの初期値は持てないのでデザイン・仕様確認 */}
          {places.map((place) => {
            const { name, placeCode } = place;

            return (
              <option key={placeCode} value={placeCode}>
                {name}
              </option>
            );
          })}
        </select>
      </div>
    </div>
  );
};

const rootStyle = css`
  display: grid;
  row-gap: 8px;
`;

const heading3Style = css`
  font-size: 18px;
  font-weight: 700;
  line-height: 28px;
`;

const selectWrapperStyle = css`
  position: relative;
`;

const selectStyle = css`
  background: #fff;
  border-radius: 6px;
  border: 1px solid #ebebeb;
  cursor: pointer;
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  width: 100%;
`;

const iconStyle = css`
  bottom: 0;
  height: 6px;
  margin-block: auto;
  pointer-events: none;
  position: absolute;
  right: 16px;
  top: 0;
`;
